// Basic lerp funtion.
export const lerp = (a1, a2, t) => a1 * (1 - t) + a2 * t

// basic clamp
export const clamp = (v, a = 0, b = 1) => (v < a ? a : v > b ? b : v)

// Backout function from tweenjs.
// https://github.com/CreateJS/TweenJS/blob/master/src/tweenjs/Ease.js
export const backout = amount => t =>
  t > 0.001
    ? --t * t * ((amount + 1) * t + amount) + 1
    : 1 - sqr(sqr(sqr(2.4 * t - 1.2)))

export const backInOut = amount => {
  amount *= 1.525
  return function (t) {
    if ((t *= 2) < 1) return 0.5 * (t * t * ((amount + 1) * t - amount))
    return 0.5 * ((t -= 2) * t * ((amount + 1) * t + amount) + 2)
  }
}

// easeInOut function based on
// https://github.com/CreateJS/TweenJS/blob/master/src/tweenjs/Ease.js
export const easeInOut = (t, pow = 2) =>
  (t *= 2) < 1
    ? 0.5 * Math.pow(t, pow)
    : 1 - 0.5 * Math.abs(Math.pow(2 - t, pow))
export const easeIn = (t, pow = 2) => Math.pow(t, pow)
export const easeOut = (t, pow = 2) => 1 - Math.pow(1 - t, pow)

// array manipulation
export const sas = (a, count) => (a + count) % count
